var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.23158H16V1.26316C16 0.912281 15.8772 0.614035 15.6316 0.368421C15.386 0.122807 15.0877 0 14.7368 0H1.26316C0.912281 0 0.614035 0.122807 0.368421 0.368421C0.122807 0.614035 0 0.912281 0 1.26316V4.23158ZM4.42105 5.49474H0V13.8737C0 14.2246 0.122807 14.5228 0.368421 14.7684C0.614035 15.014 0.912281 15.1368 1.26316 15.1368H4.42105V5.49474ZM11.5789 5.49474V15.1368H14.7368C15.0877 15.1368 15.386 15.014 15.6316 14.7684C15.8772 14.5228 16 14.2246 16 13.8737V5.49474H11.5789ZM10.3158 5.49474H5.68421V15.1368H10.3158V5.49474Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableView);
export default __webpack_public_path__ + "static/media/tableView.9d288f4d28f7aaf68f9c98fbda9c6e09.svg";
export { ForwardRef as ReactComponent };